import { InfoCircleOutlined } from '@ant-design/icons';
import { ErrorMessage } from '@hookform/error-message';
import { ReactNode } from 'react';
import { Form } from 'react-bootstrap';
import { Control, Controller, FieldPathByValue, FieldValues, useController } from 'react-hook-form';

import { OverlayTrigger, Tooltip } from '../../../bootstrap';

type Props<T extends FieldValues> = {
  // Only allow string values to be used with this component
  fieldName: FieldPathByValue<T, boolean | undefined>;
  control: Control<T>;
  label?: ReactNode;
  tooltip?: ReactNode;
  hideErrorMessage?: boolean;
  disabled?: boolean;
};

export function ControlledToggle<T extends FieldValues>({
  label,
  tooltip,
  control,
  fieldName,
  hideErrorMessage,
  disabled,
}: Props<T>) {
  const {
    formState: { errors },
  } = useController({ name: fieldName, control });
  return (
    <>
      <Controller
        control={control}
        name={fieldName}
        render={({ field }) => (
          <div className="d-flex align-items-center gap-1">
            <Form.Check
              type="switch"
              checked={field.value}
              onChange={(e) => {
                field.onChange(e);
              }}
              disabled={disabled}
            />

            <label className="u-fs-3" style={{ opacity: disabled ? 0.5 : 1 }}>
              <span>{label || (field.value ? 'Yes' : 'No')}</span>
            </label>

            {tooltip && (
              <OverlayTrigger trigger={['click', 'focus', 'hover']} rootClose overlay={<Tooltip>{tooltip}</Tooltip>}>
                <InfoCircleOutlined />
              </OverlayTrigger>
            )}
          </div>
        )}
      />

      {!hideErrorMessage && (
        <ErrorMessage
          errors={errors}
          name={fieldName as any} // This *should* work without casting but it doesn't
          render={({ message }) => <div className="u-fs-2 u-color-red1">{message}</div>}
        />
      )}
    </>
  );
}
